import { useEffect, useState } from 'react';

import MetadataService from '../../common/metadata.service';

function useMetadataLabel(
  fetchMap: () => Promise<{ [key: string]: { displayText?: string } }>,
  key: string | undefined,
): string | undefined {
  const [label, setLabel] = useState<string | undefined>(key);

  useEffect(() => {
    if (!key) {
      setLabel(undefined);
      return;
    }
    let mounted = true;
    fetchMap().then(map => {
      if (mounted) {
        setLabel(map[key]?.displayText ?? key);
      }
    });
    return () => {
      mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return label;
}

// Plain-text display label for a stage (v2), backed by the same metadata
// service `ApplicationStageV2` uses — without the colored Tag styling.
export const useApplicationStageLabel = (stage: string | undefined) =>
  useMetadataLabel(() => MetadataService.getApplicationStages(), stage);

// Plain-text display label for a detailed lifecycle, backed by the same
// metadata service `ApplicationDetailedLifecycle` uses — without the colored
// Tag styling.
export const useApplicationDetailedLifecycleLabel = (
  detailedLifecycle: string | undefined,
) =>
  useMetadataLabel(
    () => MetadataService.getApplicationDetailedLifecycles(),
    detailedLifecycle,
  );
